import store from "@/store";

// Usa a instância do store diretamente (e não useStore()) para funcionar também
// fora do setup do componente: watchers, handlers de clique e callbacks async.
export function hasFeature(feature: string) {
    const hasAccess = store.getters.currentUser?.features?.includes(feature);
    return hasAccess;
}
